import React from "react";
const Pledges = () => {
  return (
    <div>
      Pledges{" "}
    </div>
  );
};

export default Pledges;



// WEBPACK FOOTER //
// ./src/components/Pledges.js